import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
    selector: 'app-progress-busy-indicator',
    templateUrl: './progress-busy-indicator.component.html',
    styleUrls: ['./progress-busy-indicator.component.css'],
    standalone: false
})
export class ProgressBusyIndicatorComponent {
  message = 'Please wait...';
  progressUpdates: any[] = [];
  @ViewChild('progressList') private progressList!: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ProgressBusyIndicatorComponent>
  ) {
    this.message = data.message;
    this.progressUpdates = data.progressUpdates; // shared reference
  }

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  private scrollToBottom(): void {
    if (this.progressList) {
      const el = this.progressList.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
